import { render, staticRenderFns } from "./TheDraggedCustomerV2.vue?vue&type=template&id=ecd610bc&scoped=true&"
import script from "./TheDraggedCustomerV2.vue?vue&type=script&lang=js&"
export * from "./TheDraggedCustomerV2.vue?vue&type=script&lang=js&"
import style0 from "./TheDraggedCustomerV2.vue?vue&type=style&index=0&id=ecd610bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd610bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VOverlay,VProgressCircular})
